<script setup lang="ts">
import { Banknote, ChevronRight, CreditCard, PiggyBank } from 'lucide-vue-next'

// Products of all banks in one place; unlike other illustrations these are real links
const { t } = useI18n()

const logos = [
  { bank: 'Бакай Банк', logo: '/images/banks/bakai.png' },
  { bank: 'MBANK', logo: '/images/banks/mbank.png' },
  { bank: 'Демир Банк', logo: '/images/banks/demir-bank.png' }
]

const products = [
  { url: '/credits', label: 'common.credits', icon: Banknote, tone: 'bg-blue-600' },
  { url: '/deposits', label: 'common.deposits', icon: PiggyBank, tone: 'bg-emerald-500' },
  { url: '/cards', label: 'common.cards', icon: CreditCard, tone: 'bg-brand-gray' }
]
</script>

<template>
  <div class="relative w-[21rem]">
    <div class="HeroIllustrationCard">
      <div class="flex items-center gap-3">
        <div class="flex -space-x-2" aria-hidden="true">
          <template v-for="item in logos" :key="item.bank">
            <NuxtImg
              v-if="item.logo"
              :src="item.logo"
              alt=""
              width="36"
              height="36"
              class="size-9 rounded-full bg-white object-contain p-1 ring-2 ring-white"
            />
            <span
              v-else
              class="grid size-9 place-items-center rounded-full bg-blue-50 text-[0.5625rem] font-bold text-blue-700 ring-2 ring-white"
            >
              {{ item.bank }}
            </span>
          </template>
        </div>
        <div class="text-sm font-semibold leading-5">{{ t('widget.hero_banner.illustration.banks.title') }}</div>
      </div>

      <nav class="mt-4 space-y-1.5" :aria-label="t('widget.hero_banner.illustration.banks.title')">
        <NuxtLinkLocale
          v-for="product in products"
          :key="product.url"
          :to="product.url"
          class="group flex items-center gap-3 rounded-xl bg-blue-50 px-3 py-2 transition-colors hover:bg-blue-600 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600"
        >
          <span class="grid size-8 place-items-center rounded-lg text-white" :class="product.tone">
            <component :is="product.icon" class="size-4" />
          </span>
          <span class="flex-1 font-semibold">{{ t(product.label) }}</span>
          <ChevronRight class="size-4 text-gray-400 transition-transform group-hover:translate-x-0.5 group-hover:text-white" />
        </NuxtLinkLocale>
      </nav>
    </div>
  </div>
</template>
